$(document).ready(function(){
$(".footer-collapse__title").click(function() {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next(".footer-collapse__content").removeClass('active');
    } else {
        $('.footer-collapse__title').removeClass('active');
        $('.footer-collapse__content').removeClass('active');
        $(this).addClass('active');
        $(this).next(".footer-collapse__content").addClass('active');
    }
});

  
  $('.close-mobile-menu').click(function(){
    $('.main-hamburger-icon').trigger('click');
}) 
  $('.change-layout-list').click(function(){
$('.product-grid-container').find('#product-grid').removeClass('grid--2-col-tablet-down')
$('.product-grid-container').find('#product-grid').addClass('grid--1-col-tablet-down')
})
$('.change-layout-grid').click(function(){
$('.product-grid-container').find('#product-grid').removeClass('grid--1-col-tablet-down')
$('.product-grid-container').find('#product-grid').addClass('grid--2-col-tablet-down')
})

  $('.template-search .change-layout-list').click(function(){
$('.template-search .product-grid-container').find('.product-grid').removeClass('grid--2-col-tablet-down')
$('.template-search .product-grid-container').find('.product-grid').addClass('grid--1-col-tablet-down')
})
$('.template-search .change-layout-grid').click(function(){
$('.template-search .product-grid-container').find('.product-grid').removeClass('grid--1-col-tablet-down')
$('.template-search .product-grid-container').find('.product-grid').addClass('grid--2-col-tablet-down')
})  
  
 if ($(window).width() <= 1023) {  
  $('.featured-collection-list-wrapper').slick({
      slidesToShow: 1.8,   
      slidesToScroll: 1,   
      arrows: false,       
      dots: false,         
      infinite: false
  });

}
 if ($(window).width() >= 768 && $(window).width() <= 1023) { 
       $('.joie-video-column-inner-wrapper').slick({
      slidesToShow: 2.2,   
      slidesToScroll: 1,   
      arrows: false,       
      dots: false,         
      infinite: false
  });

   $('.joie-image-text-column-inner-wrapper').slick({
      slidesToShow: 2.2,   
      slidesToScroll: 1,   
      arrows: false,       
      dots: false,         
      infinite: false
  });
   
 }
 if ($(window).width() <= 767) {
    $('.joie-video-column-inner-wrapper').slick({
      slidesToShow: 1.1,   
      slidesToScroll: 1,   
      arrows: false,       
      dots: false,         
      infinite: false
  });
      $('.joie-image-text-column-inner-wrapper').slick({
      slidesToShow: 1.1,   
      slidesToScroll: 1,   
      arrows: false,       
      dots: false,         
      infinite: false
  });

 }  

$('.product-color-swatch').click(function(){  
    const variantImage = $(this).attr('data-variant-image');
    const variantId = $(this).attr('data-variant-id');
    $(this).parents('.card-wrapper').find('.product-atc-button').attr('data-variant-id',variantId)  
    if($(this).attr('data-available') == "true"){
      console.log('yes')
      $(this).parents('.card-wrapper').find('.product-atc-button').text('Add to cart');
      $(this).parents('.card-wrapper').find('.product-atc-button').removeClass('soldout')
    }else{
      console.log('no')
      $(this).parents('.card-wrapper').find('.product-atc-button').text('Sold out');
      $(this).parents('.card-wrapper').find('.product-atc-button').addClass('soldout')
    }
    $(this).parents('.product-color-swatches').find('.color-swatch').removeClass('active');
    $(this).parent('.color-swatch').addClass('active');
    if (variantImage !== null && variantImage !== undefined && variantImage !== "") {
    const productImage = $(this).parents('.card-wrapper').find('.card__media img');
      $(productImage).attr('srcset',variantImage)
    }
});
  
 $(document).on('click','.product-atc-button',function(){ 
   var dem = $(this);
    if (!$(this).hasClass('soldout')) {
     
var product_id = $(this).attr("data-variant-id"); 
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: product_id
},
  dataType: 'json', 
 success: function (data) { 
  console.log(data);
    $(this).text('Adding!')
   setTimeout(function(){
     $(this).text('Add to cart')     
     $.getJSON('/cart.json',function(data){        
       $('.cart-count-bubble [aria-hidden="true"]').text(data.item_count)
        window.location.href = '/cart';
    })
   },1000)  
 },
      error: function(xhr, status, error) {
        // Handle error and display the error message
        var errorMessage = '';                      
        if (xhr.responseJSON && xhr.responseJSON.description) {
          errorMessage = xhr.responseJSON.description;
        } else {
          errorMessage = 'An error occurred. Please try again.';
        }

        // Display the error message
        // $('.error-message').text(errorMessage).show();
        // console.log(errorMessage)
        $(dem).parents('.card-wrapper').find('.product-error-message').html(errorMessage)
        $(dem).parents('.card-wrapper').find('.product-error-message').show();
        setTimeout(function(){
          $(dem).parents('.card-wrapper').find('.product-error-message').hide();
        },2000)
      }
 });
    }
})  

  $('.product__media-item').on('click',function(){
    console.log('eee')
  })

    let currentZoom = 1; 
        let maxZoom = 1.6;
        let minZoom = 1;
        let plusIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"> <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" /> </svg>`;
        let minusIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"> <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" /> </svg>`;

      let fancySlideIndex;

        // Initialize Fancybox for all images
      Fancybox.bind('[data-fancybox="gallery"]', {
          selector: '.slick-slide:visible .product__media.media',
          mainClass : "thumb-product-fancybox",
          transitionEffect: "slide",
          loop: false,
          infinite: false,
          on: {
              "Carousel.ready Carousel.change": (fancybox) => {
                  fancySlideIndex = fancybox.getSlide().index;
                  console.log("slide : ", fancySlideIndex);
              },
              "done": (fancybox) => {

                  const toolbarColumnLeft = document.querySelector('.fancybox__toolbar__column.is-right');

                  // Check if the zoom buttons already exist
                  if (!toolbarColumnLeft.querySelector('.zoom-buttons')) {
                          const zoomControls = `
                          <div id="zoomControls" class="zoom-buttons">
                              <button id="zoomIn" class="f-button zoomIn">${plusIcon}</button>
                              <button id="zoomOut" class="f-button zoomOut">${minusIcon}</button>
                          </div>
                      `;
                      toolbarColumnLeft.insertAdjacentHTML('beforeend', zoomControls);
                  }
                      
              },
              "close": (event, fancybox , slide) => {
                  setTimeout(() => {
                      console.log("Closing Fancybox. Current slide index: ", fancySlideIndex);                    
                      $(".thumbnail-list .slick-slide").eq(fancySlideIndex).trigger('click');
                      $('.fancybox-image').css('transform', 'scale(1)');
                  }, 100);
              }
          }
      });
  
          $(document).on('click', '#zoomIn', function() {
            if (currentZoom < maxZoom) {
            currentZoom += 0.3; 
            updateZoom(currentZoom);
            }
        });

        $(document).on('click', '#zoomOut', function() {
            if (currentZoom > minZoom) {
            currentZoom -= 0.3;
            updateZoom(currentZoom);
            }
        });

        function updateZoom(zoomLevel) {
            // Apply the scale transformation to the Fancybox image
            $('.fancybox-image').css('transform', 'scale(' + zoomLevel + ')');
        }
  
})


// $(document).on('click', '.header-search-element', function() {
//   $('.search-modal__content').toggleClass('open-search-container'); 
// });

// Toggle the search modal on clicking the search icon
$(document).on('click', '.header-search-element', function(event) {
  event.stopPropagation(); // Prevent the click from bubbling up to the document
  $('.search-modal__content').toggleClass('open-search-container'); 
});

// Close the search modal when clicking outside of it
$(document).on('click', function(event) {
  if (!$(event.target).closest('.search-modal__content').length && !$(event.target).closest('.header-search-element').length) {
    $('.search-modal__content').removeClass('open-search-container');
  }
});

$(document).ready(function() {
  // Show or hide the button based on scroll position
  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {  // Adjust the value for when to show the button
      $('#back-to-top').fadeIn();
    } else {
      $('#back-to-top').fadeOut();
    }
  });

  // Scroll smoothly back to the top when the button is clicked
  $('#back-to-top').click(function() {
    $('html, body').animate({scrollTop: 0}, 600);  // Adjust the speed as needed
    return false;
  });


   // Check if the popup has been shown already
  if (!localStorage.getItem('newsletterPopupShown')) {
    // Show the popup after a delay (e.g., 3 seconds)
    setTimeout(function() {
      $('.email-subscription-popup').fadeIn();
      $('.email-subscription-overlay').fadeIn();
      $('.js-popup-teaser').fadeOut();
    }, 5000);
  }
  if (localStorage.getItem('newsletterPopupShown')) {
    if (!localStorage.getItem('newsletterPopupTeaser')) {
    $('.js-popup-teaser').fadeIn();
      console.log('teaser shown')
    }
  }

   $('#popupnewsletterForm').on('submit', function(event) {
       localStorage.setItem('newsletterPopupShown', 'true');
   })
$('.close-popup-teaser').on('click', function() {  
$('.js-popup-teaser').fadeOut();
  localStorage.setItem('newsletterPopupTeaser', 'true');
})  
  
$('.js-popup-teaser span').on('click', function() {  
      $('.email-subscription-popup').fadeIn();
      $('.js-popup-teaser').fadeOut();
      $('.email-subscription-overlay').fadeIn();
})
  
  // Close the popup when clicking the close button
  $('.close-email-popup').on('click', function() {
    $('.email-subscription-popup').fadeOut();
    $('.email-subscription-overlay').fadeOut();
          if($('.js-popup-teaser').length){
        $('.js-popup-teaser').fadeIn();
      }
    // Set a flag in localStorage indicating the popup has been shown
    localStorage.setItem('newsletterPopupShown', 'true');
    localStorage.setItem('newsletterPopupTeaser', 'true');
  });

  // Close the popup when clicking outside the popup content
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.email-subscription-popup').length && !$(event.target).closest('.js-popup-teaser').length) {
      localStorage.setItem('newsletterPopupShown', 'true');
      if($('.js-popup-teaser').length){
         if (localStorage.getItem('newsletterPopupShown')) {
            if (!localStorage.getItem('newsletterPopupTeaser')) {
            $('.js-popup-teaser').fadeIn();
              console.log('teaser shown')
            }
          }
      }
      $('.email-subscription-popup').fadeOut();
      $('.email-subscription-overlay').fadeOut();
            
    }
  });

  if (window.jQuery) {
    $.getScript('https://cdn.judge.me/widget_preloader.js');
  }

});

// document.querySelectorAll('.product__accordion details').forEach(details => {
//   details.addEventListener('toggle', function(event) {
//     // If the <details> element is open
//     if (details.open) {
//       // Close all other <details> elements
//       document.querySelectorAll('details').forEach(otherDetails => {
//         if (otherDetails !== details) {
//           otherDetails.removeAttribute('open');
//         }
//         else {
//           // Scroll to element with 150px offset
//           const offset = 170;
//           const elementPosition = details.getBoundingClientRect().top + window.pageYOffset;
//           const offsetPosition = elementPosition - offset;

//           window.scrollTo({
//             top: offsetPosition,
//             behavior: "smooth"
//           });
//         }
//       });
//     }
//   });
// });

// $(document).ready(function(){
//     function matchHeight() {
//         var maxHeight = 0;

//         // Loop through each element and find the maximum height
//         $('.card__heading.h5 a').each(function(){
//             var thisHeight = $(this).height();
//             if (thisHeight > maxHeight) {
//                 maxHeight = thisHeight;
//             }
//         });
//         $('.product-oneline-text').each(function(){
//           var thisHeight = $(this).height();
//           if (thisHeight > maxHeight) {
//               maxHeight = thisHeight;
//           }
//         });

//         // Set all elements to the maximum height
//         $('.card__heading.h5 a').height(maxHeight);
//       $('.product-oneline-text').height(maxHeight);
      
//     }

//     // Run the matchHeight function on page load
//     matchHeight();

//     // Optionally, you can re-run the function on window resize
//     $(window).resize(function(){
//         $('.card__heading.h5 a').css('height', 'auto'); // Reset heights
//       $('.product-oneline-text').css('height', 'auto'); 
//         matchHeight(); // Reapply matching height
//     });
// });